import React from 'react';
import { BedProps } from '@src/v3/interfaces/assets/svg';

const Bed = ({
  width = '21',
  height = '20',
  viewBox = '0 0 21 20',
  stroke = '#666666',
  strokeWidth,
  strokeLinecap,
  strokeLinejoin,
  useNewPaths = false,
  ...props
}: BedProps) => {
  // Old path data (default)
  const oldPaths = [
    {
      d: 'M8.75 13.125V6.25H16.875C17.538 6.25 18.1739 6.51339 18.6428 6.98223C19.1116 7.45107 19.375 8.08696 19.375 8.75V13.125',
    },
    { d: 'M1.875 16.25V3.75' },
    { d: 'M1.875 13.125H19.375V16.25' },
    { d: 'M8.75 6.25H1.875' },
  ];

  // New path data
  const newPaths = [
    {
      d: 'M7 10.5V5H13.5C14.0304 5 14.5391 5.21071 14.9142 5.58579C15.2893 5.96086 15.5 6.46957 15.5 7V10.5',
    },
    { d: 'M1.5 13V3' },
    { d: 'M1.5 10.5H15.5V13' },
    { d: 'M7 5H1.5' },
  ];

  const paths = useNewPaths ? newPaths : oldPaths;
  const defaultStrokeWidth = useNewPaths ? '1.5' : undefined;
  const defaultStrokeLinecap = useNewPaths ? 'round' : undefined;
  const defaultStrokeLinejoin = useNewPaths ? 'round' : undefined;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
      {...props}
    >
      {paths.map((path, index) => (
        <path
          key={index}
          d={path.d}
          stroke={stroke}
          strokeWidth={strokeWidth ?? defaultStrokeWidth}
          strokeLinecap={strokeLinecap ?? defaultStrokeLinecap}
          strokeLinejoin={strokeLinejoin ?? defaultStrokeLinejoin}
        />
      ))}
    </svg>
  );
};

export default Bed;
